import { JSONViewer } from './JSONViewer/JSONViewer'
import { Preloader } from './preloader'
import { IQDialog } from './IQDialog'
import { Pharmacies } from './Pharmacies'

export { JSONViewer, Preloader, IQDialog, Pharmacies }

export enum Distributor {
  INVOICES = 'Invoices',
  RX_PIONEER = 'RX Pioneer',
  RX = 'RX',
  RSNE = 'RSNE',
  CAPITAl = 'Capital',
  STANDARD = 'Standard',
  RX_TPA = 'RX_TPA',
}
